import { Alert } from 'src/design/atoms/Alert';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import { useSyncDivisions } from 'src/api/queries/admin/useSyncDivisions';
import { useAuth } from 'src/hooks/useAuth';
import { SyncButton } from 'src/design/atoms/SyncButton';
import { getErrorMessage } from 'src/utils';

export const SyncDivisionsPanel: React.FC = () => {
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState<string | null>(null);
  const { isAdmin } = useAuth();
  const syncMutation = useSyncDivisions();

  const syncDivisions = () => {
    setError(null);
    setSuccess(null);
    syncMutation.mutate(undefined, {
      onSuccess: () =>
        setSuccess(
          'Divisions sync started! Divisions will be updated in the background.',
        ),
      onError: (err) => setError(getErrorMessage(err)),
    });
  };

  return (
    <Paper withBorder p="md">
      <Stack gap="md">
        <Title order={4}>Sync Divisions</Title>
        <Text>
          Sync divisions to the system. This will update the divisions in the
          system with the latest data from Great Plains.
        </Text>
        <Text>
          Divisions are automatically synced on a daily basis. This will force a
          sync immediately.
        </Text>

        {isAdmin && (
          <SyncButton
            w="fit-content"
            onClick={() => syncDivisions()}
            loading={syncMutation.isPending}
          >
            Sync Divisions
          </SyncButton>
        )}
        {!isAdmin && (
          <Text>You must be a system administrator to sync divisions.</Text>
        )}
        {error && (
          <Alert color="red" title="Error" variant="light">
            {error}
          </Alert>
        )}
        {success && (
          <Alert color="green" title="Success" variant="light">
            {success}
          </Alert>
        )}
      </Stack>
    </Paper>
  );
};
